/** Kilo design token utilities — all values reference CSS vars defined in index.css. */
export const KILO = {
  bg: {
    page:    'bg-kilo-page',
    card:    'bg-kilo-card',
    cardAlt: 'bg-kilo-alt',
    nested:  'bg-kilo-nested',
  },
  border: {
    default: 'border border-kilo-border',
    subtle:  'border border-kilo-line',
  },
  text: {
    primary: 'text-kilo-text',
    muted:   'text-kilo-muted',
    soft:    'text-kilo-soft',
  },
  macro: {
    protein:   'text-kilo-protein',
    proteinBg: 'bg-kilo-protein/20',
    carbs:     'text-kilo-carbs',
    carbsBg:   'bg-kilo-carbs/20',
    fats:      'text-kilo-fats',
    fatsBg:    'bg-kilo-fats/20',
    produce:   'text-kilo-produce',
    produceBg: 'bg-kilo-produce/20',
  },
  gradient: {
    forest: 'kilo-surface-forest',
    copper: 'kilo-surface-copper',
    slate:  'kilo-surface-slate',
  },
  shadow: {
    card:   'shadow-kilo-card',
    raised: 'shadow-kilo-raised',
  },
  pill: {
    active:   'bg-kilo-accent text-black font-semibold',
    inactive: 'bg-kilo-nested text-kilo-soft border border-kilo-line',
  },
  radius: {
    card:   'rounded-3xl',
    nested: 'rounded-xl',
    pill:   'rounded-full',
  },
  /** Fluid type scale utilities — mirrors Apple Dynamic Type steps */
  type: {
    caption2:   'text-kilo-caption2',
    caption:    'text-kilo-caption',
    footnote:   'text-kilo-footnote',
    subhead:    'text-kilo-subhead',
    callout:    'text-kilo-callout',
    body:       'text-kilo-body',
    headline:   'text-kilo-headline font-semibold',
    title3:     'text-kilo-title3',
    title2:     'text-kilo-title2',
    title1:     'text-kilo-title1',
    largeTitle: 'text-kilo-largetitle',
  },
  /** Nested content block inside section cards (briefings, metrics, etc.) */
  inset: 'rounded-2xl border border-kilo-border bg-kilo-nested/60 p-5',
  /** Flat section row inside CoachSectionCard (no box-in-box) */
  embeddedSection: 'py-4',
  spinner: 'h-5 w-5 animate-spin rounded-full border-2 border-kilo-line border-t-kilo-accent',
  progressTrack: 'h-1.5 overflow-hidden rounded-full bg-kilo-nested',
  overlay: 'bg-kilo-page/80',
  field:
    'rounded-xl border border-kilo-line bg-kilo-alt px-3 py-2.5 text-kilo-text outline-none transition focus:border-kilo-accent/50 placeholder-kilo-soft',
  fieldLabel: 'font-mono text-kilo-caption2 uppercase tracking-widest text-kilo-soft',
  stickyHeader: 'sticky top-0 z-20 -mx-4 border-b border-kilo-border bg-kilo-page/95 px-4 py-4 backdrop-blur',
  btnSecondary:
    'flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-kilo-border bg-kilo-card text-kilo-callout font-semibold text-kilo-text transition-colors hover:border-kilo-accent/40 disabled:opacity-50',
  rowBtn:
    'flex w-full items-center justify-between rounded-xl border border-kilo-border bg-kilo-card px-5 py-4 text-kilo-callout text-kilo-text transition-colors hover:border-kilo-accent/30',
  meta:    'text-kilo-caption2 uppercase tracking-[0.2em] text-kilo-muted font-mono font-bold',
  /** WCAG AA section labels on light backgrounds (#737373) */
  sectionLabel: 'text-[11px] text-neutral-500 dark:text-neutral-400 uppercase tracking-widest font-bold',
  volumeBadge:
    'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border border-green-600/40 text-green-600 bg-green-600/8 dark:border-[#39ff14]/30 dark:text-[#39ff14] dark:bg-[#39ff14]/8',
  btnOutlineSecondary:
    'w-full py-3 rounded-xl text-sm font-medium flex items-center justify-center gap-2 border border-neutral-300 text-neutral-700 bg-white hover:bg-neutral-50 hover:border-neutral-400 dark:border-neutral-700 dark:text-neutral-300 dark:bg-transparent dark:hover:bg-neutral-800 dark:hover:border-neutral-500 transition-colors',
  heading: 'text-kilo-text font-black tracking-tight leading-tight',
} as const

export type BentoGradient = 'forest' | 'copper' | 'slate' | 'none'
